import type {RefObject} from "react";
import type {ThreeEvent} from "@react-three/fiber";
import * as THREE from "three";
import type {SidebarValues} from "../../App.tsx";

/**
 * Detects short clicks and taps on the object.
 */
export default class ClickGestures {

    onPointerDown: (e: ThreeEvent<PointerEvent>) => void;
    onPointerUp: (e: ThreeEvent<PointerEvent>) => void;

    private readonly onClicked: () => void

    private readonly CLICK_TOLERANCE = 5

    private downPositions: Map<number, { x: number; y: number; time: number }> = new Map()

    constructor(pointers: RefObject<Map<number, { x: number; y: number }>>, onClicked: () => void,
                setValues: SidebarValues
    ) {
        this.onClicked = onClicked

        this.onPointerDown = (e: ThreeEvent<PointerEvent>) => {
            if (this.intersections(e) === 0) return;

            if (pointers.current.size === 1 && pointers.current.has(e.pointerId)) {
                this.downPositions.set(e.pointerId, {
                    x: e.clientX,
                    y: e.clientY,
                    time: Date.now()
                })
            }
        }
        this.onPointerUp = (e: ThreeEvent<PointerEvent>) => {
            if (this.intersections(e) === 0) return;

            const downPos = this.downPositions.get(e.pointerId)
            if (downPos && pointers.current.size === 1) {
                const dx = Math.abs(e.clientX - downPos.x)
                const dy = Math.abs(e.clientY - downPos.y)
                const distance = Math.sqrt(dx * dx + dy * dy)
                const timeDiff = Date.now() - downPos.time
                const isClick = distance < this.CLICK_TOLERANCE && timeDiff < 500;
                if (isClick) {
                    this.onClicked();
                }
                setValues(prev => ({
                    ...prev,
                    "clicked": isClick.toString(),
                }));
                this.downPositions.delete(e.pointerId);
            }
        }

        // console.debug("playback gestures created")
    }

    intersections(e: THREE.Event & { intersections?: any[] }) {
        const hasIntersection = (e && e.intersections && e.intersections.length > 0);
        return hasIntersection ? e.intersections!.length : 0;
    }

    public dispose() {
        //console.trace("playback gestures dispose")
        // nothing to do
    }
}
